<template>
    <v-row dense>
      <v-row dense>
       
        <v-col cols="3">
          <div @click="mostrarPopupPromociones()" >
              <v-autocomplete :no-data-text="$t('sinDatos')"
                v-model="promocion" id="promocion"
                :items="promociones"
                :label="localizationFiltros.promocion"
                item-value="id"
                item-text="name"
                :disabled="disabled"
                readonly
                multiple
                :rules="[rules.obligatorio]"
                @change="popupPromociones($event)"
                >
              </v-autocomplete>
              </div>
        </v-col>
        <v-col cols="3">
            <v-autocomplete :no-data-text="$t('sinDatos')" 
                :items="propertyTypes" 
                :item-text="'nombreCompleto'" 
                item-value="id"
                :disabled = "promocion == null || disabled || promocion.length < 1"
                v-model="tipoInmueble" id="tipoInmueble" 
                clearable 
                multiple
                :label="localization.relacionInteracciones.tipoInmueble"
                :search-input.sync="searchInputTipoInmueble"
                @change="searchInputTipoInmueble=''"
            />
        </v-col>
        <v-col cols="3">
            <v-autocomplete :no-data-text="$t('sinDatos')" :items="operaciones" :item-text="'codeName'" item-value="codeValue"
                :disabled="promocion == null || disabled || promocion.length < 1"
                v-model="operacion" id="operacion" clearable multiple
                :label="localization.relacionInteracciones.operacion" 
                :search-input.sync="searchInputOperacion"
                @change="searchInputOperacion=''"
            />
        </v-col>
        <v-col cols="3">
                <div
                  @click="promocion && promocion.length === 1 ? mostrarSeleccionarInmuebles = true : null"
                  :style="(!promocion || disabled || promocion.length > 1) ? 'cursor: pointer' : ''">
                  <v-autocomplete
                    :no-data-text="$t('sinDatos')"
                    v-model="inmueblesSeleccionadosConId" id="inmueblesSeleccionadosConId"
                    :items="inmueblesSeleccionadosConId.length > 0 ? inmueblesSeleccionadosConId : []"
                    :label="localizationFiltros.inmueble"  
                    item-value="id"
                    item-text="inmuebleDesc"
                    readonly
                    multiple
                    clearable
                    :disabled="!promocion || disabled || promocion.length < 1"
                    append-icon="none"
                  >
                  <template v-slot:selection="data">
                        <div v-if="inmuebles.length < 5" >
                            {{ limpiarNombre(data.item) + ","}}
                        </div>
                        <div v-else-if="inmuebles.length >= 1 && data.index === 0">
                            {{ `${inmuebles.length} ${$t('popUpSeleccionarInmueble.itemsSeleccionados')}` }}
                        </div>
                    </template>
                  
                </v-autocomplete>
                </div>
        </v-col>
        <v-col cols="3">
            <v-text-field v-model="referencia" id="referencia" clearable
              :label="'Nº Solicitud'"
              ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-autocomplete :no-data-text="$t('sinDatos')" v-model="tipoSolicitud" id="tipoSolicitud" :items="tiposSolicitud"
            :label="localizationFiltros.tipoSolicitud" :item-text="mostrarIdioma"
            :disabled="promocion == null || disabled || promocion.length < 1"
            item-value="codigoTipoSolicitud" 
            clearable 
            multiple
            :search-input.sync="searchInputTipoSolicitud"
            @change="searchInputTipoSolicitud=''"/>
        </v-col>
        <v-col cols="3">
          <v-autocomplete :no-data-text="$t('sinDatos')" v-model="tiposInteraccion" id="tiposInteraccion" :items="listaTiposInteracciones"
            :label="localizationFiltros.tipoInteraccion" 
            item-text="descripcion"
            item-value="tipo" 
            :disabled="promocion == null || disabled || promocion.length < 1" 
            multiple 
            clearable 
            :search-input.sync="searchInputTipoInteraccion"
            @change="searchInputTipoInteraccion=''"
            />
        </v-col>
        <v-col cols="3">
            <v-text-field v-model="email" id="email" clearable
              :disabled="promocion == null || disabled || promocion.length < 1"
              :label="'Email'"></v-text-field>
        </v-col>
        
        <v-col cols="3">
          <v-autocomplete :no-data-text="$t('sinDatos')" v-model="cliente" id="cliente" :label="localizationFiltros.cliente" :items="clientes"
            item-text="name" item-value="id" multiple clearable 
            :disabled="promocion == null || disabled || promocion.length < 1"
            :search-input.sync="searchInputCliente"
            @change="searchInputCliente=''"/>
        </v-col>
        <!-- <v-col cols="3">
          <v-autocomplete :no-data-text="$t('sinDatos')" v-model="clienteEspecial" id="clienteEspecial" :label="localizationFiltros.clienteEspecial"
            :items="clientesEspeciales" :item-text="mostrarIdioma" item-value="id"
            clearable :disabled="disabled" />
        </v-col> -->

      </v-row>
      <v-row dense>
        <v-col cols="3">
          <v-row no-gutters>
            <v-col cols="12">
              <span class="v-label theme--light">
                {{localizationFiltros.fechaAlta}}
              </span>
            </v-col>
            <v-col cols="12">
              <o-date-picker v-model="aperturaDesde" id="aperturaDesde" :label="localizationFiltros.desde"
                :disabled="fechaAltadisabled || promocion.length < 1" :max="aperturaHasta" 
                clearable/>
            </v-col>
            <v-col cols="12">
              <o-date-picker v-model="aperturaHasta" id="aperturaHasta" :label="localizationFiltros.hasta"
                :disabled="fechaAltadisabled || promocion.length < 1" :min="aperturaDesde" 
                clearable/>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3">
          <v-row no-gutters>
            <v-col cols="12">
              <span class="v-label theme--light">
                {{localizationFiltros.fechaInteraccion}}
              </span>
            </v-col>
            <v-col cols="12">
              <o-date-picker v-model="interaccionDesde" id="interaccionDesde" :label="localizationFiltros.desde"
                :disabled="fechaInteraccionDisabled || promocion.length < 1" :max="interaccionHasta" 
                clearable/>
            </v-col>
            <v-col cols="12">
              <o-date-picker v-model="interaccionHasta" id="interaccionHasta" :label="localizationFiltros.hasta"
                :disabled="fechaInteraccionDisabled || promocion.length < 1" :min="interaccionDesde" 
                clearable/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
        <v-row justify="space-between" align="end">
          <v-col cols="4">
            <v-row justify="space-between" align="end">
              <v-col cols="6">
                <v-btn @click="exportarExcel"
                  color="primary" :disabled="disabled">
                  {{localizationFiltros.excel}}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-btn-toggle v-model="toggle" id="toggle" @change="untoggle">
            <v-btn active-class="none" style="opacity: 1"
              :disabled="disabled" @click="borrarFiltros">
              {{localizationFiltros.borrar}}
            </v-btn>
            <v-btn active-class="none" style="opacity: 1"
              :disabled="disabled" @click="aplicarFiltros" color="primary">
              {{localizationFiltros.aplicar}}
            </v-btn>
          </v-btn-toggle>
        </v-row>
      </v-col>
      </v-row>
      <v-fade-transition>
        <custom-dialog  v-if="mostrarSeleccionarInmuebles"
          v-model="mostrarSeleccionarInmuebles" id="mostrarSeleccionarInmuebles"
          @aceptar="mostrarSeleccionarInmuebles = $event">
          <PopUpSeleccionarInmuebles  :yaSeleccionado="inmuebles" :promoId="(promocion.length > 0 ? promocion : '')"
            :multiple="true" @selected="inmuebles = $event" :incidencias="true" />
        </custom-dialog>
      </v-fade-transition>
      <v-fade-transition>
        <custom-dialog
          v-if="mostrarSeleccionarPromociones"
          v-model="mostrarSeleccionarPromociones" id="mostrarSeleccionarPromociones"
        >
          <PopUpSeleccionarPromociones
            :multiple="false"
            @selected="popupSeleccionarPromociones($event)"
          />
        </custom-dialog>
      </v-fade-transition>
    </v-row>
  </template>
  
  <script>
  import PopUpSeleccionarInmuebles from '@/components/incidencias/PopUpSeleccionarInmuebles'
  import { mapGetters, mapActions } from 'vuex'
  import PopUpSeleccionarPromociones from '../incidencias/maestros/PopUpSeleccionarPromociones'
  import rulesMixin from '@/components/generic/rules.js'
  
  export default {
    mixins: [rulesMixin],
    components: {
      PopUpSeleccionarInmuebles,
      PopUpSeleccionarPromociones
    },
    props: {
      tipo: {
        type: String,
        default: 'relacionIncidencias'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      itramit: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        toggle: null,
        mostrarSeleccionarInmuebles: false,
        referencia: null,
        tipoSolicitud: null,
        promocion: [],
        inmuebles: [],
        cliente: null,
        clienteEspecial: null,
        aperturaDesde: null,
        aperturaHasta: null,
        interaccionDesde: null,
        interaccionHasta: null,
        revisadaDesde: null,
        revisadaHasta: null,
        revisada: null,
        origen: null,
        mostrarSeleccionarPromociones: false,
        tiposInteraccion: [],
        email: null,
        operacion:[],
        tipoInmueble:[],
        searchInputTipoInmueble: null,
        searchInputOperacion: null,
        searchInputTipoSolicitud: null,
        searchInputTipoInteraccion: null,
        searchInputCliente:null
      }
    },
    // mounted(){
    //   this.getOperaciones()
    // },
    created () {
      this.loadConfiguracion()
      this.getOperaciones()
      this.getPropertyTypes()
      this.getClientes()
    },
    computed: {
      ...mapGetters({
        promocionesIdubapi: 'incidencias/getPromocionesIdubapi',
        tiposSolicitud: 'configuracion/getTiposSolicitud',
      }),
      usuario() {
        return JSON.parse(localStorage.getItem('usuario'))
      },
      translates() {
        if (this.$store.state.tiposSolicitud.translates) {
          return this.$store.state.tiposSolicitud.translates;
        }
        return [];
      },
      localizationFiltros () {
        return this.$t('sectionInformes.filtros')
      },
      localization () {
        return this.$t('sectionInformes')
      },
      objFiltrosParaApi () {
        const idInmuebles = this.inmuebles.filter(x => x.inmuebleId !== null).map(x => {
          return x.inmuebleId
        })
        const idInmueblesEspeciales = this.inmuebles.filter(x => x.inmuebleEspecialId !== null).map(x => {
          return x.inmuebleEspecialId
        })
        
        return {
          referencia: this.referencia ? (this.referencia.trim()).split(';') : [],
          InmuebleIdSelected: idInmuebles,
          InmuebleEspecialIdSelected: idInmueblesEspeciales,
          propertyDevelopment: this.promocion,
          Customer: this.cliente ? this.cliente : null,
          specialCustomer: this.clienteEspecial ? this.clienteEspecial : null,
          export_csv: 0,
          codigoTipoSolicitud: this.tipoSolicitud,
          openDate1: this.aperturaDesde,
          openDate2:  this.aperturaHasta,
          interaccionDate1: this.interaccionDesde,
          interaccionDate2:  this.interaccionHasta,
          promociones: this.promocionesIdubapi,
          tiposInteraccion: this.tiposInteraccion,
          email: this.email ? (this.email.trim()).split(';') : [],
          operacion: this.operacion,
          tipoInmueble: this.tipoInmueble
        }
      },
      clientes () {
        if (this.$store.state.incidencias.clientesPorPromocionInmueble) {
          let todosClientes = this.$store.state.incidencias.clientesPorPromocionInmueble
          
          if(this.promocion.length > 0){
            let clientesByPromo = todosClientes.filter(x => {return x.promocionId === this.promocion[0]})
            // Filtro por inmuebles
            if(this.inmueblesSeleccionadosConId.length > 0 && this.inmueblesSeleccionadosConId != null){
              console.log(this.inmueblesSeleccionadosConId)
              let listaInmuebles = this.inmueblesSeleccionadosConId.map(x => {
                return x.id
              })
              let clientesByInmuebles = [], result = []

              for (let index = 0; index < listaInmuebles.length; index++) {
                
                result = clientesByPromo.filter(cp=> {return cp.inmuebleId === listaInmuebles[index]})
                if(result.length > 0){
                  clientesByInmuebles = clientesByInmuebles.concat(result);
                }
              }
              
              return clientesByInmuebles
            }else{
              return clientesByPromo
            }
          }else{
            return todosClientes
          }
        }
        return []
      },
      clientesEspeciales () {
        if (this.$store.state.incidencias.clientesEspeciales) {
          return this.$store.state.incidencias.clientesEspeciales
        }
        return []
      },
      promociones () {
        if (this.$store.state.incidencias.promociones) {
          return this.$store.state.incidencias.promociones
        }
        return []
      },
      inmueblesSeleccionadosConId: {
        get () {
          return this.inmuebles.map(x => {
            return {
              ...x,
              inmuebleDesc: x.inmuebleId != null ? (x.uhedit + ' - ' + x.direccion) : (x.nomInmueble),
              id: x.inmuebleId != null ? x.inmuebleId: x.inmuebleEspecialId
            }
          })
        },
        set (value) {
          return value
        }
      },
      listaTiposInteracciones(){
          return [
            {
              tipo: "alta",
              descripcion: this.localization.relacionInteracciones.alta
            },
            {
              tipo: "chat",
              descripcion: this.localization.relacionInteracciones.comunicacion
            },
            {
              tipo: "docs",
              descripcion: this.localization.relacionInteracciones.documentacion
            },
            {
              tipo: "cambio_est",
              descripcion: this.localization.relacionInteracciones.cambio_estado
            },
            {
              tipo: "cambio_tipo",
              descripcion: this.localization.relacionInteracciones.cambio_tipo
            },
            {
              tipo: "nota",
              descripcion: this.localization.relacionIncidencias.notas
            },
            {
              tipo: "parte",
              descripcion: this.localization.relacionInteracciones.generarParte
            }
          ]
      },
      fechaInteraccionDisabled:{
        get () {
          if(this.aperturaDesde !== null || this.aperturaHasta  !== null){
            return true
          }
          return false
        },
        set (value) {
          return value
        }
      },
      fechaAltadisabled:{
        get () {
          if(this.interaccionDesde !== null || this.interaccionHasta !== null){
            return true
          }
          return false
        },
        set (value) {
          return value
        }
      },
      operaciones(){
        if (this.$store.state.gestion.operations) {
          let operacionesSinFiltrar = this.$store.state.gestion.operations
          let listaOperacionesFiltradas = operacionesSinFiltrar.reduce((unique, o) => {
            if(!unique.some(obj => obj.clienteId === o.clienteId && obj.code === o.code && obj.promocionId === o.promocionId && obj.ambitoOperacionId === o.ambitoOperacionId) ) {
              o.inmueblesIds = [o.inmuebleId]
              unique.push(o);
            } else {
              unique.find(x=> x.code === o.code).inmueblesIds.push(o.inmuebleId)
            }
            return unique;
          },[]) 


          let listaOperaciones = listaOperacionesFiltradas.map(x => {
              let codeSeparado = x.code.split("/")
              return {
                ...x,
                codeValue: codeSeparado[0]+'/'+codeSeparado[1],
                codeName: codeSeparado[1]
              }
            })

            let result = listaOperaciones.reduce((unique, o) => {
                if(!unique.some(obj => obj.codeValue === o.codeValue ) ) {
                  unique.push(o);
                }
              return unique;
            },[]) 

          if(!this.promocion || this.promocion.length < 1 || this.promocion == null){ 
            return null
          }else{
            let operacionesByPromo = result.filter(x => {return x.promocionId === this.promocion[0]});

            if(this.inmueblesSeleccionadosConId.length > 0 && this.inmueblesSeleccionadosConId != null){
              let listaInmuebles = this.inmueblesSeleccionadosConId.map(x => {
                return x.id
              })
              let operacionesByInmu = []

              for (let index = 0; index < listaInmuebles.length; index++) {
                const element = listaInmuebles[index];
                operacionesByInmu.push(operacionesByPromo.find(op=> op.inmueblesIds.includes(element)))
              }
              operacionesByInmu.sort(function(a,b){
                return a.codeName - b.codeName
              });
              return operacionesByInmu
            }else{
              operacionesByPromo.sort(function(a,b){
                return a.codeName - b.codeName
              });
              return operacionesByPromo
            }
          }
          
        }
        return null
      },
      propertyTypes () {
      if (this.$store.state.incidencias.propertyTypes) {
        return this.$store.state.incidencias.propertyTypes.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    },
    methods: {
      ...mapActions({
        addAlert: 'alerts/add',
        loadConfiguracion: 'configuracion/obtenerConfiguracion',
        getOperaciones: 'gestion/getOperaciones',
        getPropertyTypes: 'incidencias/getPropertyTypes',
        getClientes: 'incidencias/obtenerClientesPorPromocionInmueble',
  
      }),
      mostrarIdioma (item) {
        if (item.translates && item.translates[this.usuario.idioma] && item.translates[this.usuario.idioma].length > 0 ) {
          return item.translates[this.usuario.idioma]
        } else {
          return item.name || item.description || item.text || ''
        }
      },
      async untoggle () {
        await this.$nextTick()
        this.toggle = null
      },
      aplicarFiltros () {
        if(this.promocion.length > 0 || (this.referencia !== null && this.referencia !== '')){
          this.$emit('aplicar', this.objFiltrosParaApi)
        }else{
          this.addAlert({texto: 'Por favor, debe selecionar una promoción o indicar un Nº de solicitud', color: 'error'})
        }
        
      },
      borrarFiltros () {
        this.reiniciarFiltros()
        this.$emit('borrar', this.objFiltrosParaApi)
      },
      exportarExcel () {
        if(this.promocion.length > 0 || (this.referencia !== null && this.referencia !== '')){
          this.$emit('exportar', {
            ...this.objFiltrosParaApi,
            export_csv: 1
          })
        }else{
          this.addAlert({texto: 'Por favor, debe selecionar una promoción', color: 'error'})
        }
      },
      reiniciarFiltros () {
        this.referencia = null
        this.tipoSolicitud = null
        this.promocion = []
        this.inmuebles = []
        this.cliente = null
        this.clienteEspecial = null
        this.aperturaDesde = null
        this.aperturaHasta = null
        this.interaccionDesde = null
        this.interaccionHasta = null
        this.cierreDesde = null
        this.cierreHasta = null
        this.tiposInteraccion = []
        this.email = null
        this.operacion = [],
        this.tipoInmueble = []
      },
      limpiarNombre(item) {
        return item.inmuebleDesc.replace("<br>", " ")
      },
      mostrarPopupPromociones () {
        if ( this.mostrarSeleccionarPromociones === false ) {
          this.mostrarSeleccionarPromociones = true
        }
        else {
          this.mostrarSeleccionarPromociones = false
        }
      },
      popupSeleccionarPromociones (promocionesSelected) {
        this.inmueble = null
        if (promocionesSelected != null && promocionesSelected.length > 0) {
          this.promocion =  promocionesSelected.map( x => x.id)
        } else {
          this.promocion = []
        }
  
      },
      fechaAltaCambiado(){
        if(this.interaccionDesde !== null || this.interaccionHasta !== null){
          this.$emit('fechaInteraccionDisabled', true)
        }
        this.$emit('fechaInteraccionDisabled', false)
      },
      fechaInteraccionCambiado(){
        if(this.aperturaDesde !== null || this.aperturaHasta  !== null){
          this.$emit('fechaAltadisabled', true)
        }
        this.$emit('fechaAltadisabled', false)
      },
      procesarCodigoOperacion(item){
        let listaCodOper = item.code.split("/")
        return (listaCodOper[1] || null)
      }
    }
  }
  </script>
  
  